import React, { useEffect, useState } from 'react';
import axios from 'axios';

const initialForm = {
  name: '',
  email: '',
};

const AdministratorCollaborators = () => {
  const [collaborators, setCollaborators] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const fetchCollaborators = () => {
    setLoading(true);
    setError('');

    axios
      .get('/api/administrator/collaborators')
      .then((response) => {
        setCollaborators(response.data || []);
      })
      .catch(() => {
        setError('No fue posible cargar los colaboradores.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCollaborators();
  }, []);

  const resetForm = () => {
    setForm(initialForm);
    setEditingId(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');

    const request = editingId
      ? axios.put(`/api/administrator/collaborators/${editingId}`, form)
      : axios.post('/api/administrator/collaborators', form);

    request
      .then(() => {
        resetForm();
        fetchCollaborators();
      })
      .catch((err) => {
        setError(err?.response?.data?.message || 'No fue posible guardar el colaborador.');
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const handleEdit = (collaborator) => {
    setEditingId(collaborator.id);
    setForm({
      name: collaborator.name || '',
      email: collaborator.email || '',
    });
  };

  const handleDelete = (collaborator) => {
    if (!window.confirm(`¿Eliminar a ${collaborator.name}?`)) {
      return;
    }

    setError('');

    axios
      .delete(`/api/administrator/collaborators/${collaborator.id}`)
      .then(() => {
        if (editingId === collaborator.id) {
          resetForm();
        }
        fetchCollaborators();
      })
      .catch(() => {
        setError('No fue posible eliminar el colaborador.');
      });
  };

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-5">
        <h3 className="mb-0">Administradores</h3>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="row">
        <div className="col-md-4">
          <div className="card card-custom gutter-b">
            <div className="card-body">
              <h5 className="mb-4">{editingId ? 'Editar Collaborator' : 'Alta de Collaborator'}</h5>

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="font-weight-bolder">Nombre</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="font-weight-bolder">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="d-flex">
                  <button
                    type="submit"
                    className="btn btn-primary font-weight-bolder mr-3"
                    disabled={saving}
                  >
                    {saving ? 'Guardando...' : editingId ? 'Actualizar' : 'Crear'}
                  </button>

                  {editingId && (
                    <button
                      type="button"
                      className="btn btn-light-primary font-weight-bolder"
                      onClick={resetForm}
                      disabled={saving}
                    >
                      Cancelar
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="col-md-8">
          <div className="card card-custom">
            <div className="card-body">
              <h5 className="mb-4">Listado de Collaborators</h5>

              {loading ? (
                <p className="text-muted mb-0">Cargando...</p>
              ) : collaborators.length === 0 ? (
                <p className="text-muted mb-0">No hay colaboradores registrados.</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-head-custom table-vertical-center">
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>Email</th>
                        <th className="text-right">Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {collaborators.map((collaborator) => (
                        <tr key={collaborator.id}>
                          <td>{collaborator.name}</td>
                          <td>{collaborator.email}</td>
                          <td className="text-right">
                            <button
                              type="button"
                              className="btn btn-sm btn-light-primary font-weight-bolder mr-2"
                              onClick={() => handleEdit(collaborator)}
                            >
                              Editar
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-light-danger font-weight-bolder"
                              onClick={() => handleDelete(collaborator)}
                            >
                              Eliminar
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdministratorCollaborators;
